import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AuthModule } from './auth/auth.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HomeModule } from './home/home.module';
import { ContainerModule } from './container/container.module';
import { AuthService } from './auth/services/auth.service';
import { OAuthStorage, OAuthModule } from 'angular-oauth2-oidc';
import { AuthInterceptor } from './auth/services/auth.interceptor';
import { FuelModule } from './fuel/fuel.module';
import { SettingsModule } from './settings/settings.module';
import { AccountModule } from './account/account.module';
import { TimelineSkipModule } from './timeline-skip/timeline-skip.module';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { TimelineArticModule } from './timeline-artic/timeline-artic.module';
import { QuotingModule } from './quoting/quoting.module';
import { JobSignoffModule } from './job-signoff/job-signoff.module';
import { InvoiceModule } from './invoice/invoice.module';
import { BatchModule } from './batch/batch.module';
import { WeighbridgeModule } from './weighbridge/weighbridge.module';
import { TimelineTransportModule } from './timeline-transport/timeline-transport.module';
import { WorkshopModule } from './workshop/workshop.module';
import { ReportingModule } from './reporting/reporting.module';
import { ReportBuilderModule } from './report-builder/report-builder.module';
import { JobSignoffLandServicesModule } from './job-signoff-land-services/job-signoff-land-services.module';
import { JobsModule } from './jobs/jobs.module';
import { ContactModule } from './contact/contact.module';
import { ContractModule } from './contract/contract.module';
import { PublicFormsModule } from './public-forms/public-forms.module';
import { JobSignoffShredderModule } from './job-signoff-shredder/job-signoff-shredder.module';
import { OpportunitiesModule } from './opportunities/opportunities.module';
import { LeadsModule } from './leads/leads.module';
import { ShredderImporterModule } from './shredder-importer/shredder-importer.module';
import { JobSignoffArticModule } from './job-signoff-artic/job-signoff-artic.module';
import { FitterModule } from './fitter/fitter.module';
import { WorkshopDefectsModule } from './workshop-defects/workshop-defects.module';
import { WalkaroundQuestionsModule } from './walkaround-questions/walkaround-questions.module';
import { VehicleInspectionsModule } from './vehicle-inspections/vehicle-inspections.module';
import { WorkshopSchedulerModule } from './workshop-scheduler/workshop-scheduler.module';
import { DeliveryNotesModule } from './delivery-notes/delivery-notes.module';
import { DepotStockLocationModule } from './depot-stock-location/depot-stock-location.module';
import { TimelineWorkshopModule } from './timeline-workshop/timeline-workshop.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule as CalendarModulePlugin, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { JobSignoffWorkshopModule } from './job-signoff-workshop/job-signoff-workshop.module';
import { ComplianceModule } from './compliance/compliance.module';
import { CalendarModule } from './calendar/calendar.module';
import { PodsModule } from './pods/pods.module';
import { JobSignoffStartModule } from './job-signoff-start/job-signoff-start.module';
import { PriceListModule } from './price-list/price-list.module';
import { TipTicketModule } from './tip-ticket/tip-ticket.module';
import { YardTradeSignoffModule } from './yard-trade-signoff/yard-trade-signoff.module';
import { JobSignoffMaterialUpliftModule } from './job-signoff-material-uplift/job-signoff-material-uplift.module';
import { ArticRunDiaryModule } from './artic-run-diary/artic-run-diary.module';
import { SimplifiedOrderingModule } from './simplified-ordering/simplified-ordering.module';
import { DriverModule } from './driver/driver.module';
import { SubcontractorModule } from './subcontractor/subcontractor.module';
import { WarehousingModule } from './warehousing/warehousing.module';

// Move to config file
// const config: SocketIoConfig = { url: 'http://localhost:3000', options: {} };


@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        OAuthModule.forRoot(),
        // SocketIoModule.forRoot(config),
        AuthModule,
        CoreModule,
        ContainerModule,
        DriverModule,
        SubcontractorModule,
        WarehousingModule,
        FuelModule,
        SettingsModule,
        AccountModule,
        TimelineSkipModule,
        TimelineArticModule,
        QuotingModule,
        JobSignoffModule,
        InvoiceModule,
        BatchModule,
        WeighbridgeModule,
        TimelineTransportModule,
        WorkshopModule,
        ReportingModule,
        ReportBuilderModule,
        JobSignoffLandServicesModule,
        JobSignoffArticModule,
        JobsModule,
        ContactModule,
        ContractModule,
        PublicFormsModule,
        JobSignoffShredderModule,
        LeadsModule,
        ComplianceModule,
        OpportunitiesModule,
        ShredderImporterModule,
        FitterModule,
        WorkshopDefectsModule,
        WalkaroundQuestionsModule,
        VehicleInspectionsModule,
        WorkshopSchedulerModule,
        DeliveryNotesModule,
        DepotStockLocationModule,
        TimelineWorkshopModule,
        JobSignoffWorkshopModule,
        PriceListModule,
        NgSelectModule,
        BrowserAnimationsModule,
        NgbModalModule,
        CalendarModulePlugin.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        CalendarModule,
        PodsModule,
        JobSignoffStartModule,
        TipTicketModule,
        YardTradeSignoffModule,
        JobSignoffMaterialUpliftModule,
        ArticRunDiaryModule,
        SimplifiedOrderingModule,
        HomeModule,
        AppRoutingModule], providers: [
        AuthService,
        { provide: OAuthStorage, useValue: localStorage },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
